import axios from "axios";
import { apiVariable } from "./apiVariable";

export type DispatcherAccountType = "C1" | "Fox";

export interface DispatcherAccount {
  id: string;
  website: string;
  login: string;
  hasPassword: boolean;
  accountType: DispatcherAccountType | null;
}

export interface DispatcherAccountWrite {
  website: string;
  login: string;
  password: string;
  accountType: DispatcherAccountType | null;
}

const endpoint = `${apiVariable}/dispatcher-passwords`;
const config = (token: string, signal?: AbortSignal) => ({
  headers: { Authorization: `Bearer ${token}` },
  signal,
});

export const dispatcherPasswordsService = {
  delete: async (token: string, id: string) => {
    await axios.delete(`${endpoint}/${id}`, config(token));
  },
  list: async (token: string, signal?: AbortSignal) =>
    (await axios.get<DispatcherAccount[]>(endpoint, config(token, signal)))
      .data,
  reveal: async (token: string, id: string, signal?: AbortSignal) =>
    (
      await axios.get<{ password: string }>(
        `${endpoint}/${id}/password`,
        config(token, signal),
      )
    ).data.password,
  save: async (token: string, entry: DispatcherAccountWrite, id?: string) =>
    (
      await (id
        ? axios.put<DispatcherAccount>(
            `${endpoint}/${id}`,
            entry,
            config(token),
          )
        : axios.post<DispatcherAccount>(endpoint, entry, config(token)))
    ).data,
};

// Do not expose response/request objects: they can contain submitted credentials.
export const dispatcherPasswordsError = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    if (error.response?.status === 401 || error.response?.status === 403)
      return "You do not have permission to access these credentials.";
    if (error.response?.status === 404)
      return "This account is no longer available. Refresh the page.";
  }
  return "Unable to access credentials. Please try again.";
};
